import { AxiosError } from 'axios';

import { MY_DISCOVERY_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { DiscoveryStatus } from '@/types/discovery.status.type';
import { ApiResponse } from '@/types/response.type';

export const createMyDiscovery = async (
  payload: DiscoveryStatus
): Promise<ApiResponse<DiscoveryStatus>> => {
  try {
    const response = await apiManager.post(MY_DISCOVERY_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
